import { IDebounceInputProsps } from "./type"
import styles from './debounceInputBox.styles.module.scss'
import { SearchIcon } from "assets"
import { DebounceInput } from "react-debounce-input";

const DebounceInputBox = (props: IDebounceInputProsps) => {
    const { onChange, value, ...other } = props
    return (
        <div className={styles.searchInput}>
            <div className={`${styles.searchInputWithIcon}`}>
                <SearchIcon />
                <DebounceInput
                    onChange={onChange}
                    value={value}
                    {...other}
                />
            </div>
        </div>
    )
}

export default DebounceInputBox